import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/modules/effect-fade.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/modules/free-mode.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../src/shared/assets/fonts/Inter-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../src/shared/assets/fonts/Inter-Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../src/shared/assets/fonts/Inter-SemiBold.woff2\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"../src/shared/assets/fonts/Inter-Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../src/shared/assets/fonts/Inter-ExtraBold.woff2\",\"weight\":\"800\",\"style\":\"normal\"}],\"variable\":\"--inter\",\"display\":\"swap\",\"adjustFontFallback\":false}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/layouts/DefaultLayout/ui/DefaultLayout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ModalsContainer"] */ "/app/src/app/layouts/DefaultLayout/ui/ModalsContainer/ModalsContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YandexPayProvider"] */ "/app/src/app/layouts/YandexPayProvider/YandexPayProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers/StoreProvider/StoreProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/global.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Category"] */ "/app/src/screens/Category/ui/Category.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/app/src/shared/ui/Accordion/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionContent"] */ "/app/src/shared/ui/Accordion/AccordionContent/AccordionContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionHeader"] */ "/app/src/shared/ui/Accordion/AccordionHeader/AccordionHeader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Container/Container.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/CustomLink/CustomLink.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ScreenSizeTracking"] */ "/app/src/shared/ui/ScreenSizeTracking/ui/ScreenSizeTracking.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Socials/Socials.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Stack/Flex/Flex.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Toaster/Toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BottomMenu"] */ "/app/src/widgets/BottomMenu/ui/BottomMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/1-h.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/1.1-h.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/1.1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/1.2-h.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/1.2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/1.3-h.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/1.3.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/2-h.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/3-h.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/3.1-h.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/3.1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/3.2-h.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/3.2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/3.svg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/shkaf-napolnyi.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/shkaf-pod-stiralku.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/shkaf-podvesnoi.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/tumba_pod_stiralku.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/tumba-napolnaya.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/tumba-navesnaya.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/tumba-s-rakovinoi.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/zerkala-s-podsvetkoi.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/zerkalnui-shkaf.png");
;
import(/* webpackMode: "eager", webpackExports: ["DownloadButton"] */ "/app/src/widgets/Footer/ui/DownloadButton/DownloadButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/Footer/ui/Footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["NavDesktop"] */ "/app/src/widgets/Footer/ui/NavDesktop/NavDesktop.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/Footer/ui/NavMobile/NavMobile.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/widgets/Header/ui/Header.tsx");
